import React, {Component} from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator';
import { Row, Col, Card, Button, Form, Image, Badge, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import moment from 'moment';
import Filter from './Filter';
import SimpleModal from "../../../components/modal/SimpleModal";
import LoadingModal from "../../../components/modal/LoadingModal";
import { getBadge, formatAccountNo } from '../../../resources/Utils';

class TransactionTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: {
        header: null,
        body: null,
        footer: null,
        variant: null,
        show: false
      },
      loadingShow: false
    }
  }

  handleModalClose = () => {
    let modal = this.state.modal;
    modal.show = false;
    this.props.onRefresh();
    this.setState({
      modal: modal,
      selected: [],
      selectedTransaction: []
    });
  }


  render() {

    const { modal, loadingShow } = this.state;
    const {
      mode,
      role,
      accessToken,
      username,
      filterCriteria,
      searchedCriteria,
      transactionList,
      transactionCount,
      onFilterCriteriaChange,
      onFilterCriteriaReset,
      onFilterCriteriaSubmit,
      onFilterCriteriaExportCSV,
      onTableChange,
      isDownloading
    } = this.props;

    const tableHeader = [
      { text: "ID", dataField: "id", hidden: true },
      { text: "Transaction No", dataField: "txnNumber", sort: true },
      { text: "Transaction Date/Time", dataField: "updatedDateTime", sort: true },
      { text: "Merchant ID", dataField: "merchantId", hidden: true},
      { text: "Merchant Name", dataField: "merchantName", hidden: true },
      { text: "Merchant Account No.", dataField: "toAcctNumber", sort: true, },
      { text: "Merchant Reference No.", dataField: "refNumber", sort: true, },
      { text: "Merchant Customer No.", dataField: "customerRef", sort: true, },
      { text: "Payer Account No.", dataField: "fromAcctNumber", sort: true, },
      { text: "Payment Channel", dataField: "paymentChannel", sort: true, },
      { text: "Amount (THB)", dataField: "amount", sort: true , align:'right',headerAlign:'center'},
      { text: "Status", dataField: "statusCode", sort: true,align:'center',headerAlign:'center',
        headerStyle: (column, colIndex) => {
          return { width: '110px'};
        }
      }
    ];

    let tableBody =
      transactionList.map((transaction) => {
        const transactionDetailLink = "/reports/transactions/view/" + transaction.txnNumber;
        const badge = getBadge(transaction.statusCode);
        return {
          id: transaction.txnNumber,
          txnNumber: <Link
            to={
              {
                pathname: transactionDetailLink,
                state: {
                  transaction: transaction,
                  badge: badge,
                  filterCriteria: searchedCriteria,
                  mode: mode,
                  role: role,
                  accessToken: accessToken,
                  username: username
                }
              }
            }>
            {transaction.txnNumber}
          </Link>,
          updatedDateTime: moment(transaction.updatedDateTime, "YYYYMMDDHHmmss").format("DD-MMM-YYYY HH:mm:ss"),
          merchantId : transaction.merchantId,
          merchantName : transaction.merchantName,
          toAcctNumber : transaction.toAcctNumber,
          refNumber : transaction.refNumber,
          customerRef : transaction.customerRef,
          fromAcctNumber : transaction.fromAcctNumber,
          paymentChannel : transaction.paymentChannel,
          amount: numeral(transaction.amount).format('0,0.00'),
          statusCode: <Badge pill variant={badge.style}>{badge.text}</Badge>,
        };
      });


    const defaultSorted = [{
      dataField: searchedCriteria.tableFilter.sortField, // if dataField is not match to any column you defined, it will be ignored.
      order: searchedCriteria.tableFilter.sortOrder // desc or asc
    }];
    const options = {
      sizePerPage:searchedCriteria.tableFilter.sizePerPage,
      page:searchedCriteria.tableFilter.page,
      custom: true,
      totalSize: transactionCount,
      sizePerPageList: [{
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }, {
        text: '75', value: 75
      }, {
        text: '100', value: 100
      }],
      alwaysShowAllBtns: true,
      firstPageText: 'First',
      prePageText: 'Prev',
      nextPageText: 'Next',
      lastPageText: 'Last'
    };

    return (
      <React.Fragment>
        <PaginationProvider pagination={paginationFactory(options)}>
            {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="id"
              data={tableBody}
              columns={tableHeader}
            >
              {toolkitprops => (
                <Card className="shadow mt-4 mx-auto card-width-1200">
                  <Card.Header className="pt-3 pb-2 bg-white">
                    <Row>
                      <Col sm={12} className="text-scb font-weight-bold">
                        Transaction Report
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm={12}>
                        <Filter
                          criteria={filterCriteria}
                          onChange={onFilterCriteriaChange}
                          onSubmit={onFilterCriteriaSubmit}
                          onReset={onFilterCriteriaReset}
                          onExportCSV={onFilterCriteriaExportCSV}
                          isDownloading={isDownloading}
                          mode={mode}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Row>
                          <Col xs={12}>
                            <BootstrapTable
                              hover
                              striped
                              bordered={false}
                              defaultSorted={defaultSorted}
                              noDataIndication={"No data found"}
                              {...toolkitprops.baseProps}
                              {...paginationTableProps}
                              remote={ {
                                filter: true,
                                pagination: true,
                                sort: true,
                                cellEdit: false
                              } }
                              onTableChange={ onTableChange }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={"auto"} className="mr-auto">
                            <span className="mr-1">Display</span>
                            <SizePerPageDropdownStandalone btnContextual="btn-scb" {...paginationProps} />
                            <span className="ml-1 mr-1">records per page.</span>
                            <PaginationTotalStandalone {...paginationProps} />
                          </Col>
                          <Col sm={"auto"}>
                            <PaginationListStandalone {...paginationProps} />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
        
        <SimpleModal
          onClose={this.handleModalClose}
          modal={modal}
        />
        <LoadingModal show={loadingShow} />
      </React.Fragment>
    );
  }
}

export default TransactionTable;